export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        d="M15.7071 10.7071C15.7073 10.707 15.707 10.7072 15.7071 10.7071C15.9512 10.463 16.0427 10.1242 15.9817 9.80901C15.9451 9.61991 15.8536 9.43934 15.7071 9.29289L8.7071 2.29289C8.3166 1.90237 7.6834 1.90237 7.2929 2.29289C6.9024 2.68342 6.9024 3.31658 7.2929 3.70711L13.5858 10L7.2929 16.2929C6.9024 16.6834 6.9024 17.3166 7.2929 17.7071C7.6834 18.0976 8.3166 18.0976 8.7071 17.7071L15.7071 10.7071Z"
        fill="currentColor"/>
</svg>
